export const USER_ROLES = {
  SUPERADMIN: {
    id: 1,
    name: 'Superadmin'
  },
  ADMIN: {
    id: 2,
    name: 'Admin'
  },
  USER: {
    id: 4,
    name: 'User'
  }
}
